import { useEffect } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { LandingHeader } from "./-landing-v1/LandingHeader";
import { LandingHero } from "./-landing-v1/LandingHero";
import { LandingSearch } from "./-landing-v1/LandingSearch";
import { LandingExamples } from "./-landing-v1/LandingExamples";
import { LandingFooter } from "./-landing-v1/LandingFooter";

export const Route = createFileRoute("/dev/prototypes/landing-v1")({
	component: LandingV1,
});

const FONT_HREF =
	"https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,600;1,400&family=Inter:wght@200;300;400&display=swap";

const ICONS_HREF =
	"https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:wght,FILL@100..700,0..1&display=swap";

function LandingV1() {
	useEffect(() => {
		const fonts = document.createElement("link");
		fonts.rel = "stylesheet";
		fonts.href = FONT_HREF;
		document.head.appendChild(fonts);

		const icons = document.createElement("link");
		icons.rel = "stylesheet";
		icons.href = ICONS_HREF;
		document.head.appendChild(icons);

		return () => {
			document.head.removeChild(fonts);
			document.head.removeChild(icons);
		};
	}, []);

	return (
		<div className="bg-warm-gray text-ivory/90 selection:bg-gold selection:text-warm-gray relative min-h-screen font-sans antialiased">
			{/* Scroll-darkening gradient overlay */}
			<div
				aria-hidden
				className="landing-v1-gradient pointer-events-none absolute inset-x-0 top-0 z-10 h-[600px]"
				style={{
					background:
						"linear-gradient(to bottom, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.4) 40%, transparent 100%)",
				}}
			/>
			<style>{`
				.landing-v1-gradient {
					opacity: 0.2;
					animation: darken-gradient linear both;
					animation-timeline: scroll();
					animation-range: 0px 400px;
				}
				@keyframes darken-gradient {
					from { opacity: 0.2; }
					to { opacity: 0; }
				}
			`}</style>

			<LandingHeader />

			<main className="relative overflow-hidden pt-40 pb-32">
				<LandingHero />
				<LandingSearch />

				<div className="mt-24">
					<LandingExamples />
				</div>
			</main>

			<LandingFooter />
		</div>
	);
}
